import React, {useEffect, useState} from 'react';
import {Form, Row, Col, Card, Table, Button, Spinner, Modal} from 'react-bootstrap';
import IconButton from 'components/common/IconButton';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import Avatar from '../../common/Avatar';
import ActionButton from '../../common/ActionButton';
import {list} from '../../../lib/api/user';
import Pagination from 'react-bootstrap/Pagination';
import {activation, remove} from '../../../lib/api/user';
import {Add} from './Add'; // oba su u istom fajlu
import {Edit} from './Edit'; // oba su u istom fajlu
import SubtleBadge from 'components/common/SubtleBadge';
import Toast from 'react-bootstrap/Toast';
import {toast} from "react-toastify";

export const List = () => {
    const status = 'Completed';
    const [searchName, setSearchName] = useState("");
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(false);

    const [addUser, setAddUser] = useState(null);
    const [editUserId, setEditUserId] = useState(null);
    const [sendingActivationFor, setSendingActivationFor] = useState(null);

    useEffect(() => {
        fetchData();
    }, [page, pageSize]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await list({p_email: searchName, page, pageSize});
            setItems(response.data);
            setTotalItems(response.totalItems);
            setTotalPages(response.totalPages);
        } catch (error) {
            console.error('Greška prilikom učitavanja podataka:', error);
        }
        setLoading(false);
    };

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    const handleAddUser = (newUser) => {
        setItems((prev) => [newUser, ...prev]);
    };

    const handleUpdateUser = (updatedUser) => {
        setItems((prev) => prev.map((p) => p.user_guid === updatedUser.user_guid ? updatedUser : p));
    };

    const handelDelete = async (id) => {
        if (!window.confirm("Da li ste sigurni da želite da izbrišete korisnika?")) {
            return;
        }

        try {
            await remove(id);
            toast.success("Korisnik je uspješno obrisan.");

            // Ako je obrisan posljednji rezultat na stranici, vrati se na prethodnu.
            if (items.length === 1 && page > 1) {
                setPage(currentPage => currentPage - 1);
            } else {
                await fetchData();
            }
        } catch (error) {
            console.error('Greška prilikom brisanja korisnika:', error);
            toast.error(error?.error?.[0]?.msg || 'Brisanje korisnika nije uspjelo.');
        }
    };

    const handelSendMail = async id => {
        setSendingActivationFor(id);

        try {
            await activation({"user_guid": id});
            toast.success("Uspjesno ste poslali mail!");
            await fetchData();
        } catch (error) {
            console.error('Greška prilikom slanja aktivacijskog maila:', error);
            toast.error(error?.error?.[0]?.msg || 'Slanje aktivacijskog maila nije uspjelo.');
        } finally {
            setSendingActivationFor(null);
        }
    };

    const handelSearch = async event => {
        fetchData(); // šalješ vrednost uneta u input
    };

    return (
        <>
            <Row className="g-3">
                <Col xs={12}>
                    <Card>
                        <Card.Body>
                            <Form.Group as={Col} md="12"
                                        method="POST"
                                        encType="multipart/form-data"
                                        noValidate
                            >
                                <Row className="flex-between-center">
                                    <Col md={6}>
                                        <Form.Control
                                            className="rounded-pill"
                                            type="text"
                                            name="name"
                                            placeholder="Pretraži po emailu"
                                            value={searchName}
                                            onChange={(e) => setSearchName(e.target.value)}
                                        />
                                    </Col>
                                    <Col xs="auto">
                                        <IconButton
                                            className="rounded-pill me-1 mb-1"
                                            variant="falcon-primary"
                                            icon="search"
                                            transform="shrink-3"
                                            onClick={() => handelSearch()}
                                        >
                                            Pretraga
                                        </IconButton>
                                    </Col>
                                </Row>
                            </Form.Group>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12}>
                    <Card className={classNames('h-100')}>
                        <Card.Header>
                            <Row className={classNames('g-2')}>
                                <Col>
                                    <Flex>
                                        <h5 className="mb-0 hover-actions-trigger text-truncate text-nowrap">Korisnici</h5>
                                    </Flex>
                                </Col>
                                <Col xs="auto">
                                    <Button onClick={() => setAddUser(true)} variant="primary">Dodaj korisnika</Button>
                                </Col>
                            </Row>
                        </Card.Header>

                        <Card.Body className="bg-body-tertiary">
                            {loading ? (
                                <div className="text-center">
                                    <Spinner animation="border" role="status"/>
                                </div>
                            ) : (
                                <Row className="mb-3">
                                    <Table responsive>
                                        <thead>
                                        <tr>
                                            <th>User</th>
                                            <th>Rola</th>
                                            <th></th>
                                            <th className="text-end">Akcije</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {items.map((item, i) => (
                                            <tr key={item.user_guid}>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        {/*<Avatar*/}
                                                        {/*    src={`http://localhost:3003/uploads/${item.user_guid}.jpg`}*/}
                                                        {/*    size="2xl" name={item.email}/>*/}
                                                        <div className="ms-2">{item.email}</div>
                                                    </div>
                                                </td>
                                                <td>{item.role_type_id}</td>
                                                <td>
                                                    <div className="ms-2">
                                                        <SubtleBadge
                                                            bg={classNames({
                                                                success: item.users_activation_type_id === 'A',
                                                                warning: item.users_activation_type_id === 'M',
                                                                danger: item.users_activation_type_id === 'N'
                                                            })}
                                                            className="fs-10 w-75"
                                                        >
                                                            {item.activation_type_name}
                                                        </SubtleBadge>

                                                    </div>
                                                </td>
                                                <td className="text-end">
                                                    <ActionButton onClick={() => setEditUserId(item.user_guid)}
                                                                  icon="edit" title="Clubs" variant="action"
                                                                  className="p-0 me-2"/>
                                                    <ActionButton onClick={() => handelDelete(item.user_guid)}
                                                                  icon="trash-alt" title="Delete" variant="action"
                                                                  className="p-0 me-2"/>
                                                    <ActionButton onClick={() => handelSendMail(item.user_guid)}
                                                                  icon="envelope" disabled={sendingActivationFor === item.user_guid} title="Send mail" variant="action"
                                                                  className="p-0"/>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </Table>
                                </Row>
                            )}
                        </Card.Body>
                        <Card.Footer>
                            <Row className="justify-content-center">
                                <Pagination className="justify-content-center">
                                    <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1}/>
                                    {[...Array(totalPages).keys()].map((index) => (
                                        <Pagination.Item key={index + 1} active={index + 1 === page}
                                                         onClick={() => handlePageChange(index + 1)}>
                                            {index + 1}
                                        </Pagination.Item>
                                    ))}
                                    <Pagination.Next onClick={() => handlePageChange(page + 1)}
                                                     disabled={page === totalPages}/>
                                </Pagination>
                            </Row>
                        </Card.Footer>

                        {/* Add Modal */}
                        {addUser && (
                            <Modal show onHide={() => setAddUser(false)} size="lg">
                                <Modal.Body>
                                    <Add onClose={() => {
                                        console.log('Ugasi addUser');
                                        setAddUser(null)
                                    }} onAdd={handleAddUser}/>
                                </Modal.Body>
                            </Modal>
                        )}

                        {/* Clubs Modal */}
                        {editUserId && (
                            <Modal show onHide={() => setEditUserId(null)} size="lg">
                                <Modal.Body>
                                    <Edit userId={editUserId} onClose={() => {
                                        setEditUserId(null)
                                    }} onUpdate={handleUpdateUser}/>
                                </Modal.Body>
                            </Modal>
                        )}
                    </Card>
                </Col>
            </Row>
        </>
    );
};
